export const DEFAULT_MARKER_WIDTH = 15;
export const DEFAULT_MARKER_HEIGHT = 15;
// shaping.js shapeIcon方法中用来计算shape值的基准icon大小
export const ICON_SIZE = 2048;
export const GLYPH_SIZE = 24;

export const DEFAULT_ICON_ALPHA_TEST = 0.01;

